"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * 表示对象类型的字符串
 * 
 * @readonly
 * @enum {string}
 */
var _default = {
  /** Array */
  ARRAY: '[object Array]',

  /** AsyncFunction */
  ASYNC_FUNCTION: '[object AsyncFunction]',

  /** Date */
  DATE: '[object Date]',

  /** Function */
  FUNCTION: '[object Function]',

  /** Null */
  NULL: '[object Null]',

  /** Number */
  NUMBER: '[object Number]',

  /** Object */
  OBJECT: '[object Object]',

  /** Promise */
  PROMISE: '[object Promise]',

  /** String */
  STRING: '[object String]',

  /** Undefined */
  UNDEFINED: '[object Undefined]'
};
exports["default"] = _default;